const ACHIEVEMENT_DATA = [
  { id: 'first-swipe', title: 'First Swipe', description: 'Answer your first round.', type: 'total', threshold: 1 },
  { id: 'warming-up', title: 'Warming Up', description: 'Answer 5 rounds.', type: 'total', threshold: 5 },
  { id: 'rookie-run', title: 'Rookie Run', description: 'Answer 10 rounds.', type: 'total', threshold: 10 },
  { id: 'daily-grind', title: 'Daily Grind', description: 'Answer 25 rounds.', type: 'total', threshold: 25 },
  { id: 'marathoner', title: 'Marathoner', description: 'Answer 75 rounds.', type: 'total', threshold: 75 },
  { id: 'centurion', title: 'Centurion', description: 'Answer 225 rounds.', type: 'total', threshold: 225 },
  { id: 'double-century', title: 'Double Century', description: 'Answer 675 rounds.', type: 'total', threshold: 675 },
  { id: 'endurance-engine', title: 'Endurance Engine', description: 'Answer 2,025 rounds.', type: 'total', threshold: 2025 },
  { id: 'signal-legend', title: 'Signal Legend', description: 'Answer 6,075 rounds.', type: 'total', threshold: 6075 },
  { id: 'first-hit', title: 'First Hit', description: 'Make your first correct call.', type: 'correct', threshold: 1 },
  { id: 'no-luck-needed', title: 'No Luck Needed', description: 'Get 3 answers correct.', type: 'correct', threshold: 3 },
  { id: 'sharp-ten', title: 'Sharp Ten', description: 'Get 10 answers correct.', type: 'correct', threshold: 10 },
  { id: 'sure-twenty-five', title: 'Sure Twenty-Five', description: 'Get 30 answers correct.', type: 'correct', threshold: 30 },
  { id: 'half-century', title: 'Half Century', description: 'Get 90 answers correct.', type: 'correct', threshold: 90 },
  { id: 'hundred-hits', title: 'Hundred Hits', description: 'Get 270 answers correct.', type: 'correct', threshold: 270 },
  { id: 'precision-engine', title: 'Precision Engine', description: 'Get 810 answers correct.', type: 'correct', threshold: 810 },
  { id: 'truth-archive', title: 'Truth Archive', description: 'Get 2,430 answers correct.', type: 'correct', threshold: 2430 },
  { id: 'three-run', title: 'Three-Run Read', description: 'Reach a 3 answer streak.', type: 'streak', threshold: 3 },
  { id: 'five-flame', title: 'Five Flame', description: 'Reach a 5 answer streak.', type: 'streak', threshold: 5 },
  { id: 'seven-sight', title: 'Seven Sight', description: 'Reach an 8 answer streak.', type: 'streak', threshold: 8 },
  { id: 'ten-thread', title: 'Ten Thread', description: 'Reach a 13 answer streak.', type: 'streak', threshold: 13 },
  { id: 'fifteen-focus', title: 'Fifteen Focus', description: 'Reach a 21 answer streak.', type: 'streak', threshold: 21 },
  { id: 'thirty-four-thread', title: 'Thirty-Four Thread', description: 'Reach a 34 answer streak.', type: 'streak', threshold: 34 },
  { id: 'fifty-five-focus', title: 'Fifty-Five Focus', description: 'Reach a 55 answer streak.', type: 'streak', threshold: 55 },
  { id: 'eighty-nine-eye', title: 'Eighty-Nine Eye', description: 'Reach an 89 answer streak.', type: 'streak', threshold: 89 },
  { id: 'steady-start', title: 'Steady Start', description: 'Hold 60% accuracy after 10 rounds.', type: 'accuracy', threshold: 0.6, minimumTotal: 10 },
  { id: 'steady-hand', title: 'Steady Hand', description: 'Hold 70% accuracy after 15 rounds.', type: 'accuracy', threshold: 0.7, minimumTotal: 15 },
  { id: 'expert-eye', title: 'Expert Eye', description: 'Hold 80% accuracy after 30 rounds.', type: 'accuracy', threshold: 0.8, minimumTotal: 30 },
  { id: 'near-oracle', title: 'Near Oracle', description: 'Hold 90% accuracy after 60 rounds.', type: 'accuracy', threshold: 0.9, minimumTotal: 60 },
  { id: 'razor-read', title: 'Razor Read', description: 'Hold 95% accuracy after 120 rounds.', type: 'accuracy', threshold: 0.95, minimumTotal: 120 },
  { id: 'diamond-eye', title: 'Diamond Eye', description: 'Hold 96% accuracy after 240 rounds.', type: 'accuracy', threshold: 0.96, minimumTotal: 240 },
  { id: 'signal-savant', title: 'Signal Savant', description: 'Hold 97% accuracy after 480 rounds.', type: 'accuracy', threshold: 0.97, minimumTotal: 480 },
  { id: 'near-perfect-read', title: 'Near Perfect Read', description: 'Hold 98% accuracy after 960 rounds.', type: 'accuracy', threshold: 0.98, minimumTotal: 960 },
  { id: 'ranked-player', title: 'Ranked Player', description: 'Reach the top 100.', type: 'rank', threshold: 100 },
  { id: 'top-fifty', title: 'Top Fifty', description: 'Reach the top 50.', type: 'rank', threshold: 50 },
  { id: 'top-twenty-five', title: 'Top Twenty-Five', description: 'Reach the top 25.', type: 'rank', threshold: 25 },
  { id: 'top-ten', title: 'Top Ten', description: 'Reach the top 10.', type: 'rank', threshold: 10 },
  { id: 'top-five', title: 'Top Five', description: 'Reach the top 5.', type: 'rank', threshold: 5 },
  { id: 'top-three', title: 'Top Three', description: 'Reach the top 3.', type: 'rank', threshold: 3 },
  { id: 'number-one', title: 'Number One', description: 'Reach rank 1.', type: 'rank', threshold: 1 },
];

function getNormalizedAchievementStats(stats = {}) {
  const total = Number(stats.total) || 0;
  const correct = Number(stats.correct ?? stats.score) || 0;
  const accuracy = Number.isFinite(Number(stats.accuracy))
    ? Number(stats.accuracy)
    : total > 0
      ? correct / total
      : 0;

  return {
    total,
    correct,
    accuracy,
    streak: Number(stats.winStream ?? stats.bestStreak ?? stats.streak) || 0,
    rank: Number(stats.rank) || 0,
  };
}

function isAchievementUnlocked(achievement, stats) {
  if (achievement.type === 'total') {
    return stats.total >= achievement.threshold;
  }

  if (achievement.type === 'correct') {
    return stats.correct >= achievement.threshold;
  }

  if (achievement.type === 'streak') {
    return stats.streak >= achievement.threshold;
  }

  if (achievement.type === 'accuracy') {
    return stats.total >= achievement.minimumTotal && stats.accuracy >= achievement.threshold;
  }

  if (achievement.type === 'rank') {
    return stats.rank > 0 && stats.rank <= achievement.threshold;
  }

  return false;
}

function clampProgress(value) {
  return Math.max(0, Math.min(100, Math.round(value)));
}

function getAchievementProgress(achievement, stats) {
  if (achievement.type === 'total') {
    return clampProgress((stats.total / achievement.threshold) * 100);
  }

  if (achievement.type === 'correct') {
    return clampProgress((stats.correct / achievement.threshold) * 100);
  }

  if (achievement.type === 'streak') {
    return clampProgress((stats.streak / achievement.threshold) * 100);
  }

  if (achievement.type === 'accuracy') {
    const totalProgress = (stats.total / achievement.minimumTotal) * 100;
    const accuracyProgress = (stats.accuracy / achievement.threshold) * 100;

    return clampProgress(Math.min(totalProgress, accuracyProgress));
  }

  if (achievement.type === 'rank') {
    if (stats.rank <= 0) {
      return 0;
    }

    return stats.rank <= achievement.threshold ? 100 : 0;
  }

  return 0;
}

export const ACHIEVEMENTS = ACHIEVEMENT_DATA;

export function getAchievements(stats) {
  const normalizedStats = getNormalizedAchievementStats(stats);

  return ACHIEVEMENTS.map((achievement) => ({
    ...achievement,
    unlocked: isAchievementUnlocked(achievement, normalizedStats),
    progress: getAchievementProgress(achievement, normalizedStats),
  }));
}
